<template lang="pug">
.generic-wrapper(v-if="blockModel")
  .container
    BackButton(name="CMSBlockModels")
    template(v-if="$route.name === 'CMSBlockModelNew'")
      h1.title Neue Komponenten Struktur
      .sub-headline Bitte füllen Sie alle erforderlichen Felder aus.
    template(v-if="$route.name === 'CMSBlockModelEdit' && blockModel.id")
      h1.title {{blockModel.name}}
      .sub-headline Zuletzt bearbeitet am {{formatDate(blockModel.updatedAt)}} Uhr
  
    .margin-top
      draggable(v-model="blockModel.blocks" v-bind="dragOptions" @change="(e) => dropBlock(e)")
        transition-group(type="transition" name="flip-list")
          .block-model(v-for="model, idx in blockModel.blocks" :key="'blockModel-'+idx")
            .name {{model.name}}
            .spacer.md
            .description {{model.description}}
            .spacer.md
            template
              b-tag(v-if="model.uuid" type="is-gray") Referenz
              b-tag(v-else type="is-primary") {{model.componentName}}
            .spacer.md
            b-field(label="Interner Name" label-position="on-border")
              b-input(placeholder="Einzigartige Identifikation" :value="model.internalName" @input="(e) => updateId(model.key, e)")
            .spacer.md
            b-field(v-if="model.config && typeof model.config.label === 'string'" label="Label" label-position="on-border")
              b-input(placeholder="Labeltext" :value="model.config.label" @input="(e) => updateLabel(model.key, e)")
              .spacer.md
            b-field(v-if="model.config && typeof model.config.validation === 'string'" label="Validierung" label-position="on-border")
              b-input(placeholder="Validierungs Expressions" :value="model.config.validation" @input="(e) => updateValidation(model.key, e)")
              .spacer.md
            b-field(v-if="model.config && typeof model.config.path === 'string'" placeholder="Ordnerpfad" label="Ordnerpfad" label-position="on-border")
              b-input(:value="model.config.path" @input="(e) => updatePath(model.key, e)")
              .spacer.md
            b-button(type="is-danger" icon-left="close" @click="() => deleteModel(model.key)")
      
      .block-model.center
        b-dropdown(aria-role='list' @change="(e) => addComponent(e)")
          template(#trigger='{ active }')
            b-button(label='Neue Komponente' type='is-light' icon-left="plus")
          b-dropdown-item(v-for="c in blockModelSpecific" aria-role='listitem' :value="c.componentName") {{c.name}}
        b-dropdown(aria-role='list' @change="(e) => addReference(e)")
          template(#trigger='{ active }')
            b-button(label='Neue Referenz' type='is-light' icon-left="plus")
          b-dropdown-item(v-for="model in blockModels" aria-role='listitem' :value="model.uuid") {{model.name}}

    .margin-top
      .label Kann inkludieren
      b-checkbox(v-for="model in blockModels" :value="blockModel.nestedAllowed.find(uuid => uuid === model.uuid) ? true : false" @input="() => toggleNestedAllowed(model.uuid)") {{model.name}}
              
    .button-wrapper.margin-top.right
      b-button(type="is-light" @click="$router.push({name: 'CMSBlockModels'})") Abbrechen
      b-button(type="is-primary" @click="saveBlockModel") Speichern
      pre {{blockModel.nestedAllowed}}

</template>

<script>
import draggable from 'vuedraggable';
import { DateTime } from "luxon";
import CMSBlockGroup from '@/components/cms/BlockGroup.vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  components: {
    CMSBlockGroup,
    draggable
  },
  props: {
    id: {
      type: [Number, String]
    }
  },
  data() {
    return {
      blockModel: null,
      blockModelSpecific: [
        {
          config: {
            label: "",
            validation: ""
          },
          value: {},
          name: "Text",
          componentName: "Text_v1"
        },
        {
          config: {
            label: ""
          },
          value: {},
          name: "Bild",
          componentName: "Image_v1"
        },
        {
          config: {
            label: ""
          },
          value: {},
          name: "PDF",
          componentName: "Pdf_v1"
        },
        {
          config: {
            label: "",
            validation: ""
          },
          value: {},
          name: "Richtext",
          componentName: "RichText_v1"
        },
        {
          config: {
            label: ""
          },
          value: {},
          name: "Click-to-Action",
          componentName: "Cta_v1"
        },
        {
          config: {},
          value: {},
          name: "Ferienobjekt",
          componentName: "RentObject_v1"
        },
        {
          config: {
            label: ""
          },
          value: {},
          name: "Datum",
          componentName: "DateSelect_v1"
        },
        {
          config: {
            label: "",
            path: ""
          },
          value: {},
          name: "URL",
          componentName: "Url_v1"
        },
        {
          config: {
            label: "",
            validation: ""
          },
          value: {},
          name: "Kategorien",
          componentName: "TagInput_v1"
        },
        {
          config: {
            label: ""
          },
          value: {},
          name: "Tabelle",
          componentName: "Table_v1"
        },
      ]
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.$store.dispatch("blockModels/findAll");
    if (this.$route.name === "CMSBlockModelEdit") {
      this.blockModel = await this.$store.dispatch("blockModels/findOne", { id: this.id });
    }

    loadingComponent.close();
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    blockModels() {
      return this.$store.state.blockModels.all;
    }
  },
  methods: {
    addComponent(e) {
      const copy = JSON.parse(JSON.stringify(this.blockModel));
      copy.blocks.push({
        ...this.blockModelSpecific.find(b => b.componentName === e),
        key: uuidv4()
      });
      this.blockModel = copy;
    },
    addReference(e) {
      const copy = JSON.parse(JSON.stringify(this.blockModel));
      const model = this.blockModels.find(b => b.uuid === e);
      // copy.blocks.push({
      //   name: model.name,
      //   uuid: model.uuid,
      //   key: uuidv4()
      // });
      copy.blocks.push({
        ...model,
        key: uuidv4()
      });
      this.blockModel = copy;
    },
    updateId(key, e) {
      const copy = JSON.parse(JSON.stringify(this.blockModel));
      const block = copy.blocks.find(c => c.key === key);
      block.internalName = e;
      this.blockModel = copy;
    },
    updateLabel(key, e) {
      const copy = JSON.parse(JSON.stringify(this.blockModel));
      const block = copy.blocks.find(c => c.key === key);
      block.config.label = e;
      this.blockModel = copy;
    },
    updateValidation(key, e) {
      const copy = JSON.parse(JSON.stringify(this.blockModel));
      const block = copy.blocks.find(c => c.key === key);
      block.config.validation = e;
      this.blockModel = copy;
    },
    updatePath(key, e) {
      const copy = JSON.parse(JSON.stringify(this.blockModel));
      const block = copy.blocks.find(c => c.key === key);
      block.config.path = e;
      this.blockModel = copy;
    },
    deleteModel(key) {
      const copy = JSON.parse(JSON.stringify(this.blockModel));
      let idx = null;
      for (let i = 0; i < copy.blocks.length; i += 1) {
        if (copy.blocks[i].key === key) {
          idx = i;
          break;
        }
      }

      if (idx !== null) {
        copy.blocks.splice(idx, 1);
        this.blockModel = copy;
      }
    },
    toggleNestedAllowed(uuid) {
      const copy = JSON.parse(JSON.stringify(this.blockModel));
      let idx = null;
      for (let i = 0; i < copy.nestedAllowed.length; i += 1) {
        if (copy.nestedAllowed[i] === uuid) {
          idx = i;
          break;
        }
      }

      if (idx !== null) {
        copy.nestedAllowed.splice(idx, 1);
        this.blockModel = copy;
      } else {
        copy.nestedAllowed.push(uuid);
        this.blockModel = copy;
      }
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    async dropBlock(payload, target) {
      console.log(payload, target);
    },
    async saveBlockModel() {
      await this.$store.dispatch("blockModels/create", this.blockModel);
      if (this.$route.name === "CMSBlockModelEdit") {
        this.blockModel = await this.$store.dispatch("blockModels/findOne", { id: this.id });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.block-model {
  box-sizing: border-box;
  padding: 16px;
  width: 100%;
  background-color: white;
  border-radius: 4px;
  border: solid 1px $gray;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .name {
    font-weight: bold;
  }
  .description {
    color: '$lightgray'
  }
}

.field {
  margin-bottom: 0 !important;
}
</style>